function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 24c-4.8 0-9.1-4-9.1-9C.9 11.4 6.4 3.7 8.8.6c.5-.7 1.6-.7 2.2 0 2.5 3.1 8.2 10.6 8.2 14.4-.1 4.9-4.4 9-9.2 9z",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _ref);
};

export default SvgComponent;